import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">Cookie Policy</h1>
        
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. What Are Cookies</h2>
            <p className="text-gray-600">
            Cookies are small text files stored on your device that help websites function properly, remember user preferences, and provide a personalized experience.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold mb-4">2. How We Use Cookies</h2>
            <p className="text-gray-600">
              We use cookies to:
            </p>
                  <ul className="list-disc ml-6 text-gray-600">
                    <li>Ensure the proper functioning of our website.</li>
                    <li>Remember your preferences and settings.</li>
                    <li>Analyze traffic and user behavior to improve our services.</li>
                    <li>Deliver personalized content and advertisements.</li>
                  </ul>
          </section>
          
          <section>
          <h2 className="text-2xl font-semibold mb-4">3. How to Manage Cookies</h2>
          <p className="text-gray-600">
            You can control cookies through your browser settings. Most browsers allow you to block or delete cookies. However, disabling cookies may impact your experience on our website.
          </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;